import request from 'shared/lib/request';
import { RPC } from 'shared/constants';

const getCollaboratoreByTipo = (
  tipo,
  agenzie,
  soloAttiveL3,
  respArea,
  senior,
  soloAttive,
  assegnazione,
  forDashboard,
  escludiTutor,
  dividiCessati = false,
  fromWeb = false
) =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_collaboratori',
      params: {
        tipoProfilo: tipo || null,
        agenzie,
        soloAttiveL3,
        respArea,
        senior,
        soloAttive,
        assegnazione,
        forDashboard,
        escludiTutor,
        dividiCessati,
        fromWeb,
      },
    },
  });

const getCollaboratoriAttivi = () =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_collaboratori',
      params: {
        tipoProfilo: '',
        soloAttive: true,
        soloAttiveL3: false,
      },
    },
  });

const getTutorAttivi = () =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_collaboratori',
      params: {
        soloTutor: true,
        soloAttive: true,
      },
    },
  });

const getTutor = () =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_collaboratori',
      params: {
        soloTutor: true,
        soloAttive: false,
      },
    },
  });

const getProgettoGiovaniByPeriodo = (periodoMese, periodoAnno) =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_progetto_giovani',
      params: {
        periodoMese,
        periodoAnno,
      },
    },
  });

const getResponsabiliByAgenzia = (agenzie) =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_responsabili_area',
      params: {
        agenzie,
      },
    },
  });

const getTutorable = (collaboratore, escludiTutee = false, codiceAgenzia) =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_tutee_by_tutor',
      params: {
        collaboratore,
        refDate: null,
        escludiTutee,
        codiceAgenzia,
      },
    },
  });

const toOptionList = (collaboratori) => collaboratori.map((obj) => ({ value: obj.id, label: obj.nominativo, contrattoAttivo: obj.contrattoAttivo }));

const getTutorableOption = (collaboratore) =>
  getTutorable(collaboratore).then((res) => ({ options: toOptionList(res.listaTutee) }));

const getCollaboratoreByTipoOption = (tipo, soloAttiveL3, agenzie, respAreaId, senior, soloAttive, forDashboard, dividiCessati, fromWeb = false) =>
  getCollaboratoreByTipo(tipo, agenzie, soloAttiveL3, respAreaId, senior, soloAttive, null, forDashboard, false, dividiCessati, fromWeb).then(
    (res) => ({ options: toOptionList(res.listaCollaboratori) })
  );

const getInfoRecesso = (collaboratore = null) =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_info_collaboratore_for_recesso',
      params: {
        collaboratore,
      },
    },
  });

const getSeniorList = (agenzie, respArea) =>
  request({
    url: RPC.GESTIONE_COLLABORATORE,
    method: 'POST',
    data: {
      method: 'get_lista_senior',
      params: {
        agenzie,
        respArea,
      },
    },
  });

const GestioneCollaboratoreService = {
  getCollaboratoreByTipo,
  getCollaboratoreByTipoOption,
  getResponsabiliByAgenzia,
  getProgettoGiovaniByPeriodo,
  getCollaboratoriAttivi,
  getTutorable,
  getTutorableOption,
  getTutorAttivi,
  getTutor,
  getInfoRecesso,
  getSeniorList,
};

export default GestioneCollaboratoreService;



// WEBPACK FOOTER //
// ./app/shared/services/rpc/gestione-collaboratore/index.js